const RequestCenterFilter = ({ data, onChangeHandler, isDownload }) => {
  return (
    <div onClick={(e) => e.stopPropagation()} className="request-center-modal tw-absolute tw-bg-white tw-border tw-border-gray-300 tw-rounded-lg tw-shadow-sideDrawer tw-w-52 tw-max-h-[200px] tw-overflow-auto">
      <div className={`form-check tw-flex tw-flex-col tw-gap-2 tw-p-2 ${isDownload ? "" : "ml-3"}`}>
        {data.map((item, index) => (
          <div key={index} className="d-flex align-items-center">
            <input
              onChange={() => {
                onChangeHandler(index);
              }}
              className="form-check-input mt-0"
              type="checkbox"
              value={item.name}
              checked={item.isChecked}
              name={item.name}
              id={item.name}
            />
            <label className={`form-check-label ${isDownload ? "pl-4" : ""}`} htmlFor={item.name}>
              {item.name}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RequestCenterFilter;
